import {ModuleWithProviders, NgModule} from '@angular/core';
import {TranslateModule} from '@ngx-translate/core';
import {MDBBootstrapModulesPro} from 'ng-uikit-pro-standard';
import {
    AppDeleteConfirmModalComponent
} from './ui-components/app-delete-confirm-modal/app-delete-confirm-modal.component';
import {BuildingsService} from './services/buildings.service';
import {RolesService} from './services/roles.service';
import {AppSelectComponent} from './ui-components/app-select/app-select.component';
import {CommonModule, registerLocaleData} from '@angular/common';
import {AppColorButtonComponent} from './ui-components/app-color-button/app-color-button.component';
import {AppColorInputComponent} from './ui-components/app-color-input/app-color-input.component';
import {AppSingleInputModalComponent} from './ui-components/app-single-input-modal/app-single-input-modal.component';
import {AppFileInputComponent} from './ui-components/app-file-input/app-file-input.component';
import {PhotoViewerComponent} from './ui-components/app-photo-viewer/photo-viewer.component';
import {PhotoViewerService} from './ui-components/app-photo-viewer/photo-viewer.service';
import {DatePickerConfigService} from './services/date-picker-config.service';
import {AddressFormatService} from './services/address-format.service';
import {DateService} from './services/date.service';
import {HttpParamsService} from './services/http-params.service';
import {AppPaginationComponent} from './ui-components/app-pagination/app-pagination.component';
import {AppWarningModalComponent} from './ui-components/app-warning-modal/app-warning-modal.component';
import {DateFormatPipe} from './date-format-pipe';
import {TranslateEnumPipe} from './enum-translate-pipe';
import {EnumsService} from './services/enums.service';
import {BuildingsContactsService} from './services/buildings-contacts.service';
import {ContactsService} from './services/contacts.service';
import {AppMailInfoModalComponent} from './ui-components/app-mail-info-modal/app-mail-info-modal.component';
import {InputValidationService} from './services/input-validation-service';
import {AppTextAreaModalComponent} from './ui-components/app-text-area-modal/app-text-area-modal.component';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {AppCheckboxListModalComponent} from './ui-components/app-checkbox-list-modal/app-checkbox-list-modal.component';
import {AppRadioListModalComponent} from './ui-components/app-radio-list-modal/app-radio-list-modal.component';
import {AppSuccessModalComponent} from './ui-components/app-success-modal/app-success-modal.component';
import {AppErrorModalComponent} from './ui-components/app-error-modal/app-error-modal.component';
import {PermissionsService} from './services/permissions-service';
import {NgSelectModule} from '@ng-select/ng-select';
import {InspectionsService} from './services/inspections.service';
import localeEn from '@angular/common/locales/en';
import localeDe from '@angular/common/locales/de';
import localeFr from '@angular/common/locales/fr';
import localeEs from '@angular/common/locales/es';
import localeNl from '@angular/common/locales/nl';
import {
    AppModalConfirmButtonComponent
} from './ui-components/app-modal-confirm-button/app-modal-confirm-button.component';
import {TitleService} from './services/title.service';
import {LeafletService} from './services/leaflet.service';
import {SettingsService} from './services/settings.service';
import {MessagingCenterService} from './services/messaging-center.service';
import {AccountSiteService} from './services/account-site.service';
import {ContactListItemComponent} from './ui-components/contact-list-item/contact-list-item.component';
import {AddressFormComponent} from './components/address-form/address-form.component';
import {ChappsCommonAngularLibraryModule} from '@npm.chapps.com/chapps.common.angular.library';
import {ContactBasicFormComponent} from './components/contact-basic-form/contact-basic-form.component';
import {NotFoundComponent} from './components/not-found/not-found.component';
import {ErrorLogService} from './error-log.service';
import {HttpHeadersService} from './services/http-headers.service';
import {HTTP_INTERCEPTORS} from '@angular/common/http';
import {AuthInterceptor} from '../../http/auth.interceptor';
import {BuildingHelperService} from './services/building-helper.service';
import {ChecklistsService} from './services/checklists.service';
import {AppSnoozeIssueModalComponent} from './ui-components/app-snooze-issue-modal/app-snooze-issue-modal.component';
import {AppTitleComponent} from './ui-components/app-title/app-title.component';
import {CreateInspectionModalComponent} from './components/create-inspection-modal/create-inspection-modal.component';
import {MultimediaService} from './services/multimedia.service';
import {TranslateCutPipe} from './translate-cut-pipe';
import {LocalStorageService} from './services/local-storage.service';
import {PlaceholderPipe} from './placeholder.pipe';
import {
    AddUpdateNodeModalComponent
} from '../buildings/checklists/components/add-update-node-modal/add-update-node-modal.component';
import {SessionStorageService} from './services/session-storage.service';
import {ActionTypeIconPipe} from './pipes/action-type-icon.pipe';
import {AddressPipe} from './pipes/address.pipe';
import {UnitSelectionModule} from "../buildings/components/unit-selection/unit-selection.module";
import {KebabCasePipe} from './pipes/string-manipulation/kebab-case.pipe';
import {CredentialsInterceptor} from "../../http/credentials.interceptor";
import {SystemUpgradeScreenModule} from "../support/system/system-upgrade-screen/system-upgrade-screen.module";
import { SummationPipe } from './summation.pipe';

registerLocaleData(localeEn);
registerLocaleData(localeDe);
registerLocaleData(localeFr);
registerLocaleData(localeEs);
registerLocaleData(localeNl);

@NgModule({
    imports: [
        CommonModule,
        TranslateModule,
        FormsModule,
        ReactiveFormsModule,
        NgSelectModule,
        MDBBootstrapModulesPro,
        ChappsCommonAngularLibraryModule,
        UnitSelectionModule,
        SystemUpgradeScreenModule,
    ],
    declarations: [
        AppDeleteConfirmModalComponent,
        AppSelectComponent,
        AppColorButtonComponent,
        AppColorInputComponent,
        AppSingleInputModalComponent,
        AppFileInputComponent,
        PhotoViewerComponent,
        AppPaginationComponent,
        AppWarningModalComponent,
        DateFormatPipe,
        TranslateEnumPipe,
        TranslateCutPipe,
        AppMailInfoModalComponent,
        AppTextAreaModalComponent,
        AppSnoozeIssueModalComponent,
        AppCheckboxListModalComponent,
        AppRadioListModalComponent,
        AppSuccessModalComponent,
        AppErrorModalComponent,
        AppModalConfirmButtonComponent,
        ContactListItemComponent,
        AddressFormComponent,
        ContactBasicFormComponent,
        NotFoundComponent,
        AppTitleComponent,
        CreateInspectionModalComponent,
        PlaceholderPipe,
        AddUpdateNodeModalComponent,
        ActionTypeIconPipe,
        AddressPipe,
        KebabCasePipe,
        SummationPipe,
    ],
    providers: [
        { provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true },
        { provide: HTTP_INTERCEPTORS, useClass: CredentialsInterceptor, multi: true },
    ],
    exports: [
        AppDeleteConfirmModalComponent,
        AppSelectComponent,
        AppColorButtonComponent,
        AppColorInputComponent,
        AppSingleInputModalComponent,
        AppFileInputComponent,
        PhotoViewerComponent,
        AppPaginationComponent,
        AppWarningModalComponent,
        DateFormatPipe,
        TranslateEnumPipe,
        TranslateCutPipe,
        AppMailInfoModalComponent,
        AppTextAreaModalComponent,
        AppSnoozeIssueModalComponent,
        AppCheckboxListModalComponent,
        AppRadioListModalComponent,
        AppSuccessModalComponent,
        AppErrorModalComponent,
        AppModalConfirmButtonComponent,
        AddressFormComponent,
        ContactBasicFormComponent,
        NotFoundComponent,
        AppTitleComponent,
        CreateInspectionModalComponent,
        PlaceholderPipe,
        AddUpdateNodeModalComponent,
        ActionTypeIconPipe,
        AddressPipe,
        KebabCasePipe,
        SummationPipe
    ]
})
export class CommonsModule {
  static forRoot(): ModuleWithProviders<CommonsModule> {
    return {
      ngModule: CommonsModule,
      providers: [
        SettingsService,
        BuildingsService,
        RolesService,
        PhotoViewerService,
        DatePickerConfigService,
        AddressFormatService,
        DateService,
        HttpParamsService,
        EnumsService,
        BuildingsContactsService,
        ContactsService,
        InputValidationService,
        PermissionsService,
        InspectionsService,
        TitleService,
        LeafletService,
        MessagingCenterService,
        AccountSiteService,
        ErrorLogService,
        HttpHeadersService,
        BuildingHelperService,
        ChecklistsService,
        MultimediaService,
        LocalStorageService,
        SessionStorageService,
      ]
    };
  }
}
